import {
  PerioChartSectionData,
  PerioSection,
} from '@dataTypes/chartingFeature.types'
import { PerioVoiceHighlight } from '@utils/perio-keyword.utils'

export const PERIO_UPPER_TEETH: readonly number[] = Array.from(
  { length: 16 },
  (_, index) => index + 1,
)

export const PERIO_LOWER_TEETH: readonly number[] = Array.from(
  { length: 16 },
  (_, index) => 32 - index,
)

export const PERIO_METRIC_LABELS = [
  'PD',
  'GM',
  'CAL',
  'Bleeding',
  'Calculus',
  'Supp',
  'Furcation',
  'Mobility',
] as const satisfies readonly (keyof PerioChartSectionData)[]

export interface PerioSectionCursorProps {
  highlightTooth: number | null
  cursorTooth: number | null
  cursorMetric: keyof PerioChartSectionData | null
}

/** Cursor fields for one table. The other arch stays referentially idle. */
export const perioSectionCursorProps = (
  section: PerioSection,
  teeth: readonly number[],
  showToothNumbers: boolean,
  cursor: PerioVoiceHighlight | null,
): PerioSectionCursorProps => {
  const onSection = cursor?.section === section
  const highlightTooth =
    showToothNumbers && cursor != null && teeth.includes(cursor.tooth)
      ? cursor.tooth
      : null
  return {
    highlightTooth,
    cursorTooth: onSection && cursor ? cursor.tooth : null,
    cursorMetric: onSection && cursor ? cursor.metric : null,
  }
}
